export default __webpack_public_path__ + "static/media/set15.3dd81d49.jpeg";